import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-loader-three-dots',
  templateUrl: './loader-three-dots.component.html',
  styleUrls: ['./loader-three-dots.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderThreeDotsComponent {}
